import { cognito } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { ChangePasswordSubmitState } from 'types';

type Payload = Required<ChangePasswordSubmitState>;

export const authChangePassword = createApiSlice<unknown, Payload>({
  name: 'authChangePassword',
  *tryGenerator(_, { payload: { password, newPassword } }) {
    yield call(cognito.changePassword, { oldPassword: password, newPassword });

    return null;
  },
});
